import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withFormContext } from './FormContext';
import shallowEqual from './utils/shallowEqual';

// istanbul ignore next
const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';

function propsWithOwnDataAndError(props) {
  const {
    data, errors, name, ...restProps
  } = props;

  return {
    ...restProps,
    name,
    ownData: data[name],
    ownError: errors[name]
  };
}

/**
 * Adds support for inline definition of validators
 *
 * @deprecated deprecated since version 0.8.0 - migrate to withInputAPI instead
 *
 * @param {function} WrappedComponent
 */
export default function withValidation(WrappedComponent) {
  class Validated extends Component {
    componentDidMount() {
      const {
        defaultValue, name, onChange, registerValidators, validators
      } = this.props;

      if (validators.length || Object.keys(validators).length) {
        registerValidators(name, validators);
      }

      if (defaultValue) {
        onChange(name, defaultValue);
      }
    }

    shouldComponentUpdate(nextProps) {
      const ownProps = propsWithOwnDataAndError(this.props);
      const ownNextProps = propsWithOwnDataAndError(nextProps);

      return !shallowEqual(ownProps, ownNextProps);
    }

    componentDidUpdate({ validators: oldValidators }) {
      const { name, registerValidators, validators } = this.props;

      if (
        oldValidators !== validators
        && JSON.stringify(oldValidators) !== JSON.stringify(validators)
      ) {
        registerValidators(name, validators);
      }
    }

    componentWillUnmount() {
      const { name, unregisterValidators } = this.props;

      unregisterValidators(name);
    }

    render() {
      return <WrappedComponent {...this.props} value={this.props.data[this.props.name]} />;
    }
  }

  Validated.displayName = `Validated(${getDisplayName(WrappedComponent)})`;

  Validated.propTypes = {
    data: PropTypes.shape({}).isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    registerValidators: PropTypes.func,
    unregisterValidators: PropTypes.func,
    validators: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  };

  Validated.defaultProps = {
    defaultValue: undefined,
    onChange: /* istanbul ignore next */ () => {},
    registerValidators: /* istanbul ignore next */ () => {},
    unregisterValidators: /* istanbul ignore next */ () => {},
    validators: []
  };

  return withFormContext(Validated);
}
